"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Clickable = _interopRequireDefault(require("../Clickable"));

var _capitalize = _interopRequireDefault(require("../utils/capitalize"));

var _ButtonModule = _interopRequireDefault(require("./Button.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _clsx;

  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'contained' : _props$variant,
      other = _objectWithoutProperties(props, ["children", "className", "color", "component", "disabled", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx2["default"])('btn-startIcon', "iconSize-".concat((0, _capitalize["default"])(size)))
  }, startIconProp);

  var endIcon = endIconProp && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx2["default"])('btn-endIcon', "iconSize-".concat((0, _capitalize["default"])(size)))
  }, endIconProp);

  return /*#__PURE__*/_react["default"].createElement(_Clickable["default"], _extends({
    className: (0, _clsx2["default"])(_ButtonModule["default"].btn, (_clsx = {}, _defineProperty(_clsx, _ButtonModule["default"]["color".concat((0, _capitalize["default"])(color))], color === 'default'), _defineProperty(_clsx, _ButtonModule["default"]['btn--sm'], size === 'small'), _defineProperty(_clsx, _ButtonModule["default"]['btn--lg'], size === 'large'), _defineProperty(_clsx, _ButtonModule["default"].disabled, disabled), _defineProperty(_clsx, _ButtonModule["default"].outlined, variant === 'outlined'), _defineProperty(_clsx, _ButtonModule["default"].contained, variant === 'contained'), _defineProperty(_clsx, _ButtonModule["default"]['w-100'], fullWidth), _clsx), className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _clsx2["default"])(_ButtonModule["default"].focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/_react["default"].createElement("span", {
    className: _ButtonModule["default"].label
  }, startIcon, children, endIcon));
});

Button.propTypes = {
  /**
   * The content of the button.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['default', 'inherit', 'primary', 'secondary', 'accent']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes["default"].bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: _propTypes["default"].bool,

  /**
   * Element placed after the children.
   */
  endIcon: _propTypes["default"].node,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes["default"].string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes["default"].string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),

  /**
   * Element placed before the children.
   */
  startIcon: _propTypes["default"].node,

  /**
   * @ignore
   */
  type: _propTypes["default"].string,

  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['outlined', 'contained'])
};
var _default = Button;
exports["default"] = _default;